import React from 'react';

export function DashboardFooter() {
  return (
    <div className="bg-white px-1.5 py-0.5 border-gray-200 border-t shrink-0">
      <div className="flex justify-between items-center gap-1">
        <span className="flex items-center gap-1 text-[10px] text-gray-500">
          <span className="bg-green-500 rounded-full w-1 h-1 shrink-0" />
          Systems OK
        </span>
      </div>
    </div>
  );
}
